function linkValidation(link: string): boolean {
  return (
    !!link &&
    !link.match(
      /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/g
    )
  );
}

export default linkValidation;
